import { History } from 'history'
import { i18n as I18N } from 'i18next'

import { HttpClient } from 'modules/http-client'
import { ForFeatureFnReturn } from 'modules/module-loader'

import { LookupService } from './components/lookup/lookup.service'
import { I18nService } from './services/i18n.service'
import { Logger } from './services/logger.service'
import { RouterService } from './services/router.service'
import { SignalRService } from './services/signalR.service'
import { epics, reducers, STORE_ID } from './store'

export interface Providers {
  logger: Logger
  routerService: RouterService
  i18nService: I18nService
  lookupService: LookupService
  signalRService: SignalRService
}

interface Injectables {
  httpClient: HttpClient
  history: History
  i18n: I18N
}
export class CoreModule {
  static forRoot({ history, i18n, httpClient }: Injectables): ForFeatureFnReturn<Providers> {
    const logger = new Logger()
    const routerService = new RouterService(history)
    const i18nService = new I18nService(i18n, logger)
    const lookupService = new LookupService(httpClient)
    const signalRService = new SignalRService(httpClient)

    const providers = {
      logger,
      routerService,
      i18nService,
      lookupService,
      signalRService,
    }

    return {
      providers,
      epics,
      store: {
        id: STORE_ID,
        reducers,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts